import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppConstants, IMenuOption } from 'src/app/models';
import { SidebarService } from 'src/app/services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isToggledSidebar: boolean;
  currentPath = 'home';

  menu: IMenuOption[] = AppConstants.GetMenu;

  constructor(private sidebarService: SidebarService,
    private router: Router) {
    this.isToggledSidebar = true;
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.menuMapper(event.url)
    });
  }

  ngOnInit(): void {
  }

  toggleSidebar(): void {
    this.isToggledSidebar = !this.isToggledSidebar;
    this.sidebarService.isToggled.next(this.isToggledSidebar);
  }

  menuMapper(target: string): void { // Mapea la ruta dirigida hacia un nombre 
    console.log('headerComponent');

    if (!target || target === '/home') this.currentPath = 'Inicio';
    this.menu.forEach(x => {
      if (x.Children.length > 0) {
        x.Children.forEach(y => {
          if (y.Route === (target)) this.currentPath = y.Name;
        });
      }
      else {
        if (x.Route === (target)) this.currentPath = x.Name;
      }
    });
  }

}
